import React from 'react';
import { Box, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

const EmptyState = ({ message = 'No records found' }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 6,
      color: 'text.secondary',
    }}
  >
    <InboxIcon sx={{ fontSize: 64, mb: 2, opacity: 0.5 }} />
    <Typography variant="body1">{message}</Typography>
  </Box>
);

export default EmptyState;